module.exports = __webpack_public_path__ + "img/person-biking-mountain.5fa9513c.svg";